<template>
  <div class="">
      <footer class="footer theme-bg">
      <section class="footer-section">
        <div class="container">
          <div class="row">
            <div class="col-md-3 col-lg-5 mb-4">
              <a class="navbar-brand" href="https://devmoment.com" title="Oracle AI">
                 <img src="@/assets/new-logo-white.png" style="height: 35px; margin-bottom: 10px;" alt="Oracle">            
              </a> <br>

              <p class="ft-16">A range of AI products and solutions built by devMoment.</p>
                <ul class="social-icons">
                  <!-- <li><a class="twitter" href="https://twitter.com/thedevmoment" target="_blank" title="Oracle AI"><i class="fab fa-twitter"></i></a></li> -->
                </ul>
            </div> <!-- col -->
              <div class="col-6 col-md-3 col-lg-2 sm-m-15px-tb">

                <h5 class="font-alt">Projects</h5>
                <ul class="fot-link">
                  <li><a href="" title="Oracle AI">Computer Vision</a></li>
                  <li><a href="" title="Oracle AI">NLP</a></li>
                </ul>

              </div> <!-- col -->


              <div class="col-6 col-md-3 col-lg-2 mb-4">

                <h5 class="font-alt">Company</h5>

                <ul class="fot-link">
                  <li><a href="https://devmoment.com">blog</a></li>
                </ul>
              </div>
            <div class="col-md-3 col-lg-3">
              <h5 class="font-alt">Get in touch</h5>
              <p><span>Email:</span> ehiagheaigg@gmail.com </p>
              <p>
                <ul data-v-584ac9ef="" class="social-icons">
                  <li data-v-584ac9ef="">
                    <a data-v-584ac9ef="" href="https://www.facebook.com/ehiaig" target="_blank" title="Oracle" class="facebook"><i data-v-584ac9ef="" class="fab fa-facebook-f"></i></a>
                  </li>
                  <li data-v-584ac9ef="">
                    <a data-v-584ac9ef="" href="https://twitter.com/aigehi" target="_blank" title="" class="twitter"><i data-v-584ac9ef="" class="fab fa-twitter"></i></a>
                  </li>
                </ul>
            </p>

            </div> <!-- col -->
            
          </div>
          
          <div class="footer-copy">
            <div class="row">
              <div class="col-12">
                <p>{{ new Date().getFullYear() }} © Oracle by devMoment. All Rights Reserved.</p>
              </div><!-- col -->
            </div> <!-- row -->
          </div> <!-- footer-copy -->
        </div> <!-- container -->   
      </section>
    </footer>
</div>
</template>

<script>
export default {
  name: "FooterArea"
}
</script>